<template>
  <div>
    <card :class="'card-catalog-'+theme">
      <div class="card-header">
        <h4 class="card-title text-center toptrader-color">
          <i class="nc-icon nc-email-85"></i>
          SAC - Serviço de Atendimento ao Cliente
          <br>
          <small>
            Já consultou nossa
            <router-link to="faq" href="/user" class="text-warning">FAQ?</router-link>
          </small>
        </h4>
      </div>
      <div class="card-body" v-if="sacMode==='index'">
        <div class="row" v-if="loadingSacMessages" v-loading="loadingSacMessages" id="loading"></div>
        <card v-if="!loadingSacMessages" :class="'card-catalog-'+theme">
          <div class="pull-left" slot="header">
            <h4 class="card-title">Meus Chamados</h4>
          </div>
          <div class="pull-right" slot="header">
            <button
              class="btn btn-round btn-fill"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary'"
              @click="handleNew()"
            >
              <i class="nc-icon nc-simple-add"></i> Abrir Chamado
            </button>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="sacMessages">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="subject" label="Assunto"></el-table-column>
                <el-table-column prop="responseMessages.data.length" label="Respostas"></el-table-column>
                <el-table-column prop="solved" label="Status"></el-table-column>
                <el-table-column prop="created_at.date" label="Criado em"></el-table-column>
                <el-table-column label="Ações">
                  <div class="td-actions" slot-scope="props">
                    <a
                      v-tooltip.top-center="'Abrir'"
                      class="btn btn-warning btn-link btn-xs"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <hr>
          <h4 class="card-title text-right text-danger">
            <small>
              <a
                class="btn btn-round btn-fill text-white"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                v-if="loadingDoneText!=='Não há avisos registrados.'"
                @click.prevent="loadMore()"
              >
                <i class="nc-icon nc-circle"></i> Carregar Mais
              </a>
              <br>
              {{ loadingDoneText }}
            </small>
          </h4>
        </card>
      </div>
      <div class="card-body" v-if="sacMode==='edit'">
        <card>
          <div class="pull-left" slot="header">
            <h4 class="card-title">Chamado SAC TopTrader</h4>
            <br>
          </div>
          <div class="pull-right" slot="header">
            <button class="btn btn-round" @click="updateSacMessages()">
              <i class="nc-icon nc-bullet-list-67"></i> Todos Chamados
            </button>
          </div>
          <hr>
          <div class="row col-md-12">
            <h4 class="col-md-6 card-title">
              <small>Assunto:</small>
              {{this.sacMessages[selectedSacMessage].subject}}
            </h4>
            <h4 class="col-md-6 card-title">
              <small>Criado em:</small>
              {{this.sacMessages[selectedSacMessage].created_at.date}}
            </h4>
            <h4 class="col-md-6 card-title">
              <small>Status:</small>
              {{this.sacMessages[selectedSacMessage].solved}}
            </h4>
          </div>
          <hr>
          <form class="text-center col-md-12">
            <div>
              <el-input
                class="col-md-12"
                type="textarea"
                col="10"
                rows="5"
                maxlength="3000"
                v-model="newSacResponse.boby"
                placeholder="Responda* aqui"
              ></el-input>
              <br>
              <small class="pull-right">(Máximo de 3000 caracteres.)</small>
              <br>
              <div>
                <button
                  class="btn btn-round btn-fill"
                  :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                  type="submit"
                  @click.prevent="submitNewResponse()"
                >
                  <i class="nc-icon nc-send"></i> Enviar
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
          <div
            class="row col-md-12"
            v-for="(response, index) in sacMessages[selectedSacMessage].responseMessages.data"
            :key="response.id"
          >
            <h4 class="col-md-12 card-title">
              <small>
                - {{response.subject}}.
                Enviado por {{response.sender.data.name}} em {{response.created_at.date | moment("DD/MM/YYYY, HH:MM:SS")}}:
              </small>
              <br>
              {{response.boby}}
              <hr>
            </h4>
          </div>
          <h4 class="col-md-12 card-title">
            <small>- Mensagem Original enviada por você em {{this.sacMessages[selectedSacMessage].created_at.date}}:</small>
            <br>
            {{this.sacMessages[selectedSacMessage].boby}}
          </h4>
        </card>
      </div>
    </card>
    <el-dialog center title="Atendimento SAC TopTrader" zz :visible.sync="modals.centered">
      <div class="col-md-12">
        <hr>
        <form class="text-center col-md-12">
          <div>
            <el-select
              class="select-primary col-md-8"
              size="large"
              placeholder="Selecione o Assunto Aqui..."
              v-model="newSacMessage.subject"
            >
              <el-option
                v-for="option in selects.subjects"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
            <br>
            <br>
            <el-input
              class="col-md-8"
              type="textarea"
              col="10"
              rows="10"
              maxlength="3000"
              v-model="newSacMessage.boby"
              placeholder="Digite sua mensagem* aqui"
            ></el-input>
            <br>
            <small>(Máximo de 3000 caracteres.)</small>
            <br>
            <br>
            <div>
              <button
                class="btn btn-primary btn-fill btn-wd"
                type="submit"
                @click.prevent="submitNewSacMessage()"
              >
                <i class="nc-icon nc-send"></i> Enviar
              </button>
            </div>
          </div>
          <div class="clearfix"></div>
        </form>
        <hr>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import swal from "sweetalert2";
import moment from "moment-timezone";
import {
  Loading,
  Table,
  TableColumn,
  Dialog,
  Select,
  Option
} from "element-ui";

moment.tz.setDefault("America/Sao_Paulo");
Vue.use(Loading.directive);
Vue.use(require("vue-moment"));

export default {
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false
      },
      selects: {
        subjects: [
          { value: "Elogio", label: "Elogio" },
          { value: "Sugestão", label: "Sugestão" },
          { value: "Informação", label: "Informação" },
          { value: "Reclamação", label: "Reclamação" },
          { value: "Solicitação", label: "Solicitação" }
        ]
      },
      selectedSacMessage: 0,
      sacMode: "index",
      newSacMessage: {
        subject: "",
        boby: ""
      },
      newSacResponse: {
        subject: "",
        boby: "",
        parent_message_id: ""
      },
      loadingSacMessages: true,
      loadingDoneText: "",
      sacMessages: [],
      page: 1
    };
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchSacMessages() {
      this.loadingSacMessages = true;
      this.page = 1;
      this.axios
        .get("/support?page=" + this.page + "&include=responseMessages")
        .then(response => {
          if (response.data) {
            if (response.data.data.length === 0) {
              this.loadingDoneText = "Não há atendimentos registrados.";
            } else {
              response.data.data.forEach(sacMessage => {
                sacMessage.created_at.date = moment(
                  sacMessage.created_at.date
                ).format("DD/MM/YYYY, H:m:s");
                sacMessage.solved = sacMessage.solved
                  ? "Concluído"
                  : "Em Aberto";
              });
              this.sacMessages = response.data.data;
              console.log(this.sacMessages);
            }
            this.loadingSacMessages = false;
          }
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao carregar atendimento. Tente novamente. \n" + error);
          this.loadingSacMessages = false;
        });
    },
    updateSacMessages() {
      this.sacMode = "index";
      this.fetchSacMessages();
    },
    loadMore() {
      this.loadingSacMessages = true;
      this.page++;
      this.axios
        .get("/support?page=" + this.page + "&include=responseMessages")
        .then(response => {
          if (response.data.data.length === 0) {
            this.loadingDoneText =
              "Todos os atendimentos foram carregados com sucesso.";
          } else {
            this.sacMessages = this.noticeMessages.concat(response.data.data);
          }
          this.loadingSacMessages = false;
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao carregar mais avisos. Tente novamente \n." + error);
          this.loadingSacMessages = false;
        });
    },
    handleNew() {
      this.openModal("centered");
    },
    handleEdit(index, row) {
      this.selectedSacMessage = index;
      this.sacMode = "edit";
    },
    showSwal() {
      swal({
        title: `Enviado com sucesso!`,
        text: "Sua mensagem será respondida aqui em até 48 Hrs.",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-primary btn-fill",
        type: "success"
      });
    },
    submitNewSacMessage() {
      this.axios
        .post("/support", this.newSacMessage)
        .then(response => {
          this.newSacMessage = { subject: "", boby: "" };
          this.closeModal("centered");
          this.showSwal();
          this.fetchSacMessages();
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao enviar seu chamado. Tente novamente. \n" + error);
        });
    },
    submitNewResponse() {
      this.loadingSacMessages = true;
      this.newSacResponse.subject =
        "Resposta: [" + this.sacMessages[this.selectedSacMessage].subject + "]";
      this.newSacResponse.parent_message_id = this.sacMessages[
        this.selectedSacMessage
      ].id;
      this.axios
        .post("/support", this.newSacResponse)
        .then(response => {
          this.newSacResponse = {
            subject: "",
            boby: "",
            parent_message_id: ""
          };
          this.showSwal();
          this.fetchSacMessages();
          this.loadingSacMessages = false;
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao enviar sua resposta. Tente novamente. \n" + error);
          this.loadingSacMessages = false;
        });
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchSacMessages();
  }
};
</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Sac.vue